import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, TablePaginationConfig } from "antd";
import { COLOR_PRIMARY_BG } from "theme/colors";

export const getPaginationProps = (): TablePaginationConfig => ({
  position: ["bottomCenter"],
  hideOnSinglePage: true,
  pageSize: 10,
  showSizeChanger: false,
  style: {
    backgroundColor: COLOR_PRIMARY_BG,
    borderRadius: "0 0 8px 8px",
    margin: 0,
    padding: "10px",
    border: "1px solid #33333D",
    borderTop: "none !important"
  },
  itemRender(page, type, element) {
    if (type === "prev") {
      return (
        <Button
          style={{
            backgroundColor: "#283583",
            color: "#CECFD2",
            marginRight: "auto",
            border: "none"
          }}>
          {<ArrowLeftOutlined />}
          Previous
        </Button>
      );
    }
    if (type === "next") {
      return (
        <Button
          style={{
            backgroundColor: "#283583",
            color: "#CECFD2",
            marginLeft: "auto",
            border: "none"
          }}>
          Next
          {<ArrowRightOutlined />}
        </Button>
      );
    }
    return element;
  }
});
